import { useEffect, useState } from 'react'

export type TimeLeft = {
  hours: string
  minutes: string
  seconds: string
}

function msUntilEndOfDay(): number {
  const now = new Date()
  const end = new Date(now)
  end.setHours(23, 59, 59, 999)
  return Math.max(0, end.getTime() - now.getTime())
}

function format(ms: number): TimeLeft {
  const totalSeconds = Math.floor(ms / 1000)
  return {
    hours: String(Math.floor(totalSeconds / 3600)).padStart(2, '0'),
    minutes: String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0'),
    seconds: String(totalSeconds % 60).padStart(2, '0'),
  }
}

export function useCountdown(): TimeLeft {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>(() =>
    format(msUntilEndOfDay()),
  )

  useEffect(() => {
    const id = window.setInterval(() => {
      setTimeLeft(format(msUntilEndOfDay()))
    }, 1000)
    return () => window.clearInterval(id)
  }, [])

  return timeLeft
}
